import React, {Component} from "react";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {AppState} from "../../RootReducer";
import {Settings} from "../../http/protocol";
import "./styles/LanguageMenu.scss";
import ActiveItem from "./ActiveItem";
import Item from "./Item";
import {getContainer} from "../../ioc/IOCSetup";
import {Locale} from "../../contenful/types";
import {UserService} from "../../user/UserService";
import {changeLng} from "../../contenful/ContentfulActions";
import {LoginStatus} from "../../http/Types";
import {changeLocaleDirectory} from "../../i18n";


interface State {
    clicked: boolean;
}

interface Props {
    settings?: Settings;
    changeLng: typeof changeLng;
    inNavMenu: boolean;
    scrolled?: boolean;
    loggedIn: boolean;
    className?: string;
}

export class LanguageMenu extends Component<Props, State>{
    locales: Array<Locale> | undefined;
    defaultLocale: Locale;
    userService: UserService | undefined;
    languageOrder: string;
    constructor(props: Props){
        super(props);

        this.locales = getContainer().getSettingsService().getLocalesData();
        this.defaultLocale = getContainer().getSettingsService().getDefaultLocale();
        this.userService = getContainer().getUserService();
        this.languageOrder = getContainer().getSettingsService().getLanguageOrder();

        this.state = {
            clicked: false,
        }
    }

    handleClick = () => {
        this.setState({clicked: !this.state.clicked});
    }

    handleClickLanguage = async (lng?: string) => {
        console.log("handle click change language : ", lng);
        if(lng) {
            if (this.props.loggedIn) {
                await this.userService?.updateUserLocale(lng)
            }
            changeLocaleDirectory(lng);
        }
    }

    activeLocale = () => {
        if(this.locales) {
            let locale = this.locales.find((locale) => locale.code === getContainer().getSettingsService().getActiveLocale().code);
            if(locale === undefined) {
                locale = this.defaultLocale;
            }

            return locale;
        }

    }

    cleanAndLowerCase(input: string): string {
        return input.replace(/\s+/g, '').toLowerCase();
    }

    sortLocales = (locales: Array<Locale>, languageOrder: string) => {
        return locales.sort((a, b) => {
            // Assign a large value if the locale is not in the languageOrder
            const indexA = languageOrder.indexOf(a.code) !== -1 ? languageOrder.indexOf(a.code) : languageOrder.length;
            const indexB = languageOrder.indexOf(b.code) !== -1 ? languageOrder.indexOf(b.code) : languageOrder.length;

            return indexA - indexB;
        });    }

    render() {
        let languageOrder = this.cleanAndLowerCase(this.languageOrder);
        let sortedLocales = this.locales ? this.sortLocales(this.locales, languageOrder) : undefined;

        let scrolled = this.props.scrolled !== undefined ? this.props.scrolled : true;
        let dropDownContent = !this.props.inNavMenu
            ? `dropdown-content footer`
            : scrolled ? `dropdown-content scrolled` : "dropdown-content";
        let dropdown = !this.props.inNavMenu ? `dropdown footer` : "dropdown";
        return (
            <React.Fragment>
            {
                this.props.settings && this.locales !== undefined && this.locales.length > 1
                    ? (
                        <div className={`hide-in-context language-menu-container ${this.props.className ?? ""}`}>
                            <div className={dropdown}>
                                <div onClick={this.handleClick} className={this.state.clicked ? `dropbtn` : "dropbtn"}>
                                    {
                                        this.locales && (
                                            <ActiveItem locale={this.activeLocale()} clicked={this.state.clicked} onClick={this.handleClick} animateArrow={true} />
                                        )
                                    }
                                </div>
                                <div className={this.state.clicked ? dropDownContent + ` clicked` : "dropdown-content"}>
                                    {
                                        sortedLocales && sortedLocales.map((locale: Locale, index: number) => {
                                            return <Item key={index} locale={locale} onClick={this.handleClickLanguage}/>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    )
                    : null
            }
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({settings, user} : AppState) => {
    return {
        settings: settings.settings,
        loggedIn : LoginStatus.LOGGED_IN == user.status,
    }
}


const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        changeLng: () => dispatch(changeLng())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageMenu);